import React, { Component } from "react";
import { confirmAccount } from "../actions";
import { connect } from "react-redux";
import { ConfirmEmailComponent } from "./ConfirmEmailComponent";
import UserWrapper from "../shared/UserWrapper";
import { translate } from "react-i18next";
class ConfirmEmailContainer extends Component {
  componentDidMount() {
    this.props.confirmAccount(this.props.location.search);
  }

  render() {
    return (
      <UserWrapper headerless>
        <ConfirmEmailComponent {...this.props} />
      </UserWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    phase: state.account.phase
  };
};

const mapDispatchToProps = dispatch => {
  return {
    confirmAccount: query => {
      dispatch(confirmAccount(query));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(ConfirmEmailContainer));



// WEBPACK FOOTER //
// ./src/users/loggedUser/ConfirmEmail/index.js